<div class="main-modal-bg">
    <div class="preview-container-laptop">
        <img src="../../../assets/img/preview/preview-containers/laptop.png" class="laptop-img">
        <iframe allowfullscreen="" frameborder="0" id="iframeang" width="1200px" height="1000px" [src]="iframeSrc" class="laptop-iframe" id="laptop-iframe"></iframe>

    </div>
</div>


